import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './service-proxies';

@Injectable()
export class DashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Dashboard Data
     * @param targetYear Target year for dashboard data
     * @param billsInfoStartDate Bills info start date
     * @param billsInfoEndDate Bills info end date
     * @param vehicleCreationStartTime Vehicle creation start time
     * @param vehicleCreationEndTime Vehicle creation end time
     * @param vehicleBrandSalesStartDate Vehicle brand sales start date
     * @param vehicleBrandSalesEndDate Vehicle brand sales end date
     * @param customersStartDate Customers start date
     * @param customersEndDate Customers end date
     * @param employeesStartDate Employees start date
     * @param employeesEndDate Employees end date
     * @param salesYear Sales year
     * @param serviceSalesStartDate Service sales start date
     * @param serviceSalesEndDate Service sales end date
     * @return Dashboard data
     */
    getDashboardData(
        targetYear: number,
        billsInfoStartDate: string,
        billsInfoEndDate: string,
        vehicleCreationStartTime: string,
        vehicleCreationEndTime: string,
        vehicleBrandSalesStartDate: string,
        vehicleBrandSalesEndDate: string,
        customersStartDate: string,
        customersEndDate: string,
        employeesStartDate: string,
        employeesEndDate: string,
        salesYear: number,
        serviceSalesStartDate: string,
        serviceSalesEndDate: string
    ): Observable<DashboardDataDto> {
        let url_ = this.baseUrl + "/api/services/app/DashboardService/GetDashboardData?";
        url_ += "TargetYear=" + encodeURIComponent("" + targetYear) + "&";
        url_ += "BillsInfoStartDate=" + encodeURIComponent(billsInfoStartDate) + "&";
        url_ += "BillsInfoEndDate=" + encodeURIComponent(billsInfoEndDate) + "&";
        url_ += "VehicleCreationStartTime=" + encodeURIComponent(vehicleCreationStartTime) + "&";
        url_ += "VehicleCreationEndTime=" + encodeURIComponent(vehicleCreationEndTime) + "&";
        url_ += "VehicleBrandSalesStartDate=" + encodeURIComponent(vehicleBrandSalesStartDate) + "&";
        url_ += "VehicleBrandSalesEndDate=" + encodeURIComponent(vehicleBrandSalesEndDate) + "&";
        url_ += "CustomersStartDate=" + encodeURIComponent(customersStartDate) + "&";
        url_ += "CustomersEndDate=" + encodeURIComponent(customersEndDate) + "&";
        url_ += "EmployeesStartDate=" + encodeURIComponent(employeesStartDate) + "&";
        url_ += "EmployeesEndDate=" + encodeURIComponent(employeesEndDate) + "&";
        url_ += "SalesYear=" + encodeURIComponent("" + salesYear) + "&";
        url_ += "ServiceSalesStartDate=" + encodeURIComponent(serviceSalesStartDate) + "&";
        url_ += "ServiceSalesEndDate=" + encodeURIComponent(serviceSalesEndDate);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "json",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.get<DashboardDataDto>(url_, options_);
    }
}

export interface DashboardDataDto {
    // Define your dashboard data structure here
    // Example properties:
    [key: string]: any;
}
